import { getFunctions, httpsCallable } from "firebase/functions";

/**
 * billing.js — client data layer for Stripe billing callables.
 *
 * The only client→Stripe hop is navigating to the Checkout/Portal `url` these
 * return; all Stripe API + webhook work happens server-side in functions/src/stripe/.
 * In hermetic E2E (STRIPE_FAKE=1) the returned url points at the mock Stripe
 * server's fake Checkout/Portal HTML page, so no real network is hit.
 */

/**
 * Start a Stripe Checkout session for an upgrade.
 * @param {{tier:"lite"|"pro", interval:"month"|"year", successUrl:string, cancelUrl:string}} params
 * @returns {Promise<{url:string, sessionId:string}>}
 */
export async function createCheckoutSession({ tier, interval, successUrl, cancelUrl }) {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "createCheckoutSession");
  const response = await callable({ tier, interval, successUrl, cancelUrl });
  return response.data;
}

/**
 * Open the Stripe Customer Billing Portal (manage/cancel/switch/update card).
 * @param {{returnUrl:string}} params
 * @returns {Promise<{url:string}>}
 */
export async function openBillingPortal({ returnUrl }) {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "createBillingPortalSession");
  const response = await callable({ returnUrl });
  return response.data;
}
